import { render, staticRenderFns } from "./EditOrganizationDialog.vue?vue&type=template&id=1ad22dbd&"
import script from "./EditOrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./EditOrganizationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports